import * as React from 'react';
import { SVGType } from '../types';

type IShareIconProps = SVGType;

export const ShareIcon: React.FunctionComponent<IShareIconProps> = ({ stroke = '#1C1327', size = 16, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 24 24">
      <path
        stroke={stroke}
        d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684zm0-9.316a3.003 3.003 0 004.025 1.341 3 3 0 10-4.025-1.341z"
      ></path>
    </svg>
  );
};

export default ShareIcon;
